var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgriculture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      color: "white"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0293 19.523V7.49597",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0394 0.5C9.49257 0.985579 9.05171 1.57871 8.74442 2.24235C8.43712 2.90598 8.26996 3.62585 8.25342 4.35699C8.25342 8.54199 11.8044 8.542 11.8044 4.293C11.7805 3.57456 11.6118 2.86834 11.3085 2.21661C11.0052 1.56487 10.5736 0.981024 10.0394 0.5V0.5Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3174 6.47593C14.5872 6.4325 13.8559 6.5402 13.1692 6.79227C12.4825 7.04435 11.8551 7.43539 11.3264 7.94094C8.36743 10.8999 10.8774 13.4109 13.8824 10.4069C14.3738 9.88194 14.7541 9.2632 15.0007 8.58774C15.2473 7.91228 15.355 7.19401 15.3174 6.47593Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3174 11.7811C14.5874 11.7378 13.8562 11.8455 13.1697 12.0976C12.4832 12.3497 11.856 12.7406 11.3274 13.246C8.36841 16.205 10.8784 18.7161 13.8834 15.7121C14.3746 15.187 14.7548 14.5682 15.0012 13.8927C15.2476 13.2173 15.3551 12.4991 15.3174 11.7811V11.7811Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70737 6.47605C5.43744 6.43264 6.16862 6.54035 6.85517 6.79242C7.54171 7.0445 8.16886 7.43553 8.69737 7.94105C11.6564 10.9001 9.14638 13.411 6.14138 10.407C5.65006 9.88207 5.2698 9.2633 5.02339 8.58783C4.77698 7.91235 4.66949 7.19407 4.70737 6.47605V6.47605Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70737 11.781C5.43744 11.7376 6.16862 11.8453 6.85517 12.0973C7.54171 12.3494 8.16886 12.7405 8.69737 13.246C11.6564 16.205 9.14638 18.716 6.14138 15.712C5.65006 15.187 5.2698 14.5682 5.02339 13.8927C4.77698 13.2173 4.66949 12.499 4.70737 11.781V11.781Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgriculture);
export default __webpack_public_path__ + "static/media/agriculture.f1b32ed990ab424f930296ba53c7338b.svg";
export { ForwardRef as ReactComponent };